import { Snackbar } from '@mui/material'
import { useAppVersionCheck } from '@/hooks/useAppVersionCheck'
import AppUpdateBannerView from './AppUpdateBannerView'

/** Top banner when a newer deploy is available. */
export default function AppUpdateBanner() {
  const { updateAvailable, reloadToUpdate, dismiss } = useAppVersionCheck()
  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ top: { xs: 12, sm: 16 }, zIndex: (t) => t.zIndex.snackbar + 1000 }}
    >
      <div>
        <AppUpdateBannerView onRefresh={reloadToUpdate} onDismiss={dismiss} />
      </div>
    </Snackbar>
  )
}
